import { ChevronLeftIcon, ChevronRightIcon } from "@/components/appIcons";

export function ReleaseImageLightboxNavigation({
  imageLabel,
  onNext,
  onPrevious,
  visible,
}: {
  imageLabel: string;
  onNext: () => void;
  onPrevious: () => void;
  visible: boolean;
}) {
  if (!visible) return null;

  return (
    <>
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          onPrevious();
        }}
        className="absolute left-4 top-1/2 z-20 flex size-12 -translate-y-1/2 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
        aria-label="Previous photo"
      >
        <ChevronLeftIcon className="text-2xl" />
      </button>
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          onNext();
        }}
        className="absolute right-4 top-1/2 z-20 flex size-12 -translate-y-1/2 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
        aria-label="Next photo"
      >
        <ChevronRightIcon className="text-2xl" />
      </button>
      <span className="absolute bottom-4 left-1/2 z-20 -translate-x-1/2 rounded-full bg-white/10 px-3 py-1.5 text-sm font-medium text-white">
        {imageLabel}
      </span>
    </>
  );
}
